<app-loading
  [isLoading]="(loadingService.loading$ | async) == true"
></app-loading>
<router-outlet />
